import { render, staticRenderFns } from "./WelcomeTour.vue?vue&type=template&id=1b2c0284"
import script from "./WelcomeTour.vue?vue&type=script&lang=js"
export * from "./WelcomeTour.vue?vue&type=script&lang=js"
import style0 from "./WelcomeTour.vue?vue&type=style&index=0&id=1b2c0284&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports